import ServerAction from './ServerAction';

export default ServerAction.extend({

  isApplicable: function () {
    return this.module.selected.length === 1 && this.module.selected[0].apiToken !== "" ? true : false;
  }
});
